import React, { useRef, memo, useCallback } from 'react'
import { IContextMenuProps } from './types'
import { useDropdownState } from 'hooks/useDropdownState'
import MoreDotsIcon from 'assets/svgr-icons/More_Dots.svg'
import * as Styled from './styled'
import { translate } from 'utils/translations'
import ActionsFlyout from 'common-components/ActionsFlyout'
import { T } from 'consts/translationKeys'

const ContextMenu: React.FC<IContextMenuProps> = (props: IContextMenuProps) => {
  const {
    className,
    absolutePosition,
    onToggle,
    onClose,
    size = 'medium',
    wrapped = true,
    ...rest
  } = props
  const anchorRef = useRef<HTMLDivElement>(null)
  const { isOpen, closeDropdown, toggleDropdown } = useDropdownState()

  const handleToggle = () => {
    toggleDropdown()
    onToggle?.()
  }

  const handleClose = useCallback(() => {
    closeDropdown()
    onClose?.()
  }, [closeDropdown, onClose])

  return (
    <div className={className}>
      <Styled.TogglerWrapper
        ref={anchorRef}
        onClick={handleToggle}
        $size={size}
        $wrapped={wrapped}
        $isToggled={isOpen}
        $absolutePosition={absolutePosition}
        aria-label={translate(T.MORE_ACTIONS_LABEL)}
      >
        <MoreDotsIcon />
      </Styled.TogglerWrapper>
      <ActionsFlyout
        isOpen={isOpen}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        {...rest}
      />
    </div>
  )
}

export default memo(ContextMenu)
